const FORCE_UPGRADE_UI_KEY = "billing_force_upgrade_ui_v1";

const safeParse = (value) => {
  if (!value) return null;
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (error) {
    return null;
  }
};

const normalizeAccountId = (accountId) => {
  if (accountId == null) return null;
  const numeric = Number(accountId);
  if (Number.isFinite(numeric) && numeric > 0) {
    return String(numeric);
  }
  return String(accountId);
};

export const setForceUpgradeUi = (accountId, enabled) => {
  const normalizedAccountId = normalizeAccountId(accountId);
  if (!normalizedAccountId) return;

  if (enabled) {
    sessionStorage.setItem(
      FORCE_UPGRADE_UI_KEY,
      JSON.stringify({
        accountId: normalizedAccountId,
        forced: true,
      })
    );
    return;
  }

  const stored = safeParse(sessionStorage.getItem(FORCE_UPGRADE_UI_KEY));
  if (!stored) return;

  if (String(stored.accountId) === normalizedAccountId) {
    sessionStorage.removeItem(FORCE_UPGRADE_UI_KEY);
  }
};

export const getForceUpgradeUi = (accountId) => {
  const normalizedAccountId = normalizeAccountId(accountId);
  if (!normalizedAccountId) return false;

  const stored = safeParse(sessionStorage.getItem(FORCE_UPGRADE_UI_KEY));
  if (!stored) return false;

  return (
    stored.forced === true &&
    String(stored.accountId) === normalizedAccountId
  );
};

